import { Routes } from '@angular/router';
import { AuthGuard } from 'app/authentication/guard/auth.guard';

import { PromptuaryPage } from './components/promptuary-page/promptuary-page.component';

export const PromptuaryRoutes: Routes = [
	{
		path: 'promptuary/:appointmentId/:clientId',
		component: PromptuaryPage,
		canActivate: [AuthGuard],
	},
];
